import { render, staticRenderFns } from "./other_operate_modal_2_005.vue?vue&type=template&id=5da88bdd"
import script from "./other_operate_modal_2_005.vue?vue&type=script&lang=js"
export * from "./other_operate_modal_2_005.vue?vue&type=script&lang=js"
import style0 from "./other_operate_modal_2_005.vue?vue&type=style&index=0&id=5da88bdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports